
import React from "react";
import { Schemes, Utils } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Checkbox, Dropdown, Form, RadioButton, TextInput, useSearchParams } from "@rivtn/noseur";
import { Siren } from "../../../shared/ConfirmDialog";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { ApiResponseData, BaseService, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse, TeamService } from "../../../../services";
import { Elements } from "../../../shared/Elements";

export interface TeamHistoryProps {
    profile: IMember;
}

function TeamHistory(_: TeamHistoryProps) {

    const teamLabels = i18nManager.Labels.teams;
    const teamService = TeamService.getInstance();
    const memberService = MemberService.getInstance();
    const [teams, setTeams] = React.useState<ApiResponseData<ITeam>>({});
    const labels = i18nManager.Labels.account.profile_website.team_history;
    const [profileWebsite, setProfileWebsite] = React.useState<IProfileWebsite>();
    const { searchParams, updateSearchParam, updateSearchParams } = useSearchParams({ defaultInit: window.location.search });

    React.useEffect(() => {
        fetchTeams();
    }, [searchParams]);

    React.useEffect(() => {
        memberService.getProfileWebsite().then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.profile_website.title} - {labels.title}</span>
        </div>
        {!profileWebsite
            ? (<div style={{ margin: "90px 110px" }}>
                <img alt={"loading"} src={LoadingGif} style={{ width: 80, margin: "auto" }} />
            </div>)
            : (<Form scheme={Schemes.OMNEHOST} className="profile-settings">
                <Checkbox label={labels.enable_ad} defaultChecked={profileWebsite?.team_history_settings?.enable_rivtn_ad} onChange={(e: any) => {
                    updateProfileWebsite({ ...profileWebsite, team_history_settings: { ...profileWebsite.team_history_settings, enable_rivtn_ad: e.checked } })
                }} />
                <hr />
                <Checkbox label={labels.show_previous_team} defaultChecked={profileWebsite?.team_history_settings?.show_previous_teams} onChange={(e: any) => {
                    updateProfileWebsite({ ...profileWebsite, team_history_settings: { ...profileWebsite.team_history_settings, show_previous_teams: e.checked } })
                }} />
                <Checkbox label={labels.show_current_team} defaultChecked={profileWebsite?.team_history_settings?.show_current_teams} onChange={(e: any) => {
                    updateProfileWebsite({ ...profileWebsite, team_history_settings: { ...profileWebsite.team_history_settings, show_current_teams: e.checked } })
                }} />
                <hr />
                <div className="pagination">
                    {Elements.buildPaginator(teams ?? {},
                        ({ currentPage }, size) => updateSearchParams({ "page": currentPage, size }),
                        parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                    {Elements.buildSorter(teamLabels.sorts, (sort) => updateSearchParams({ sort }), teamLabels.sorts[0].label)}
                </div>
                <div className="query-section">
                    <div className="query-inputs" style={{ display: "flex" }}>
                        {teamLabels.query_inputs.map((fontControl) => (<TextInput key={fontControl.name} scheme={Schemes.OMNEHOST}
                            placeholder={fontControl.placeholder} defaultValue={searchParams.get(fontControl.name) ?? undefined}
                            onInputComplete={(v) => updateSearchParam(fontControl.name, v)} />))}
                        <Dropdown noIcon scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: false, style: { minWidth: 200 } }}
                            selectedOptionIndex={(teamLabels.dropdown_form_control.options!.findIndex((p) => p?.value === (searchParams.get("status"))) ?? 0)}
                            textInputProps={{ style: { paddingLeft: 15 } }} dontMatchTargetSize placeholder={teamLabels.dropdown_form_control.title}
                            options={teamLabels.dropdown_form_control.options} onSelectOption={(option) => {
                                updateSearchParam("status", option.value);
                            }} />
                    </div>
                </div>
                <hr />
                <div className="my-his-teams">
                    {(!teams.content) && Elements.LOADING_STATE}
                    {teams.content?.map?.((team) => {

                        return (<div key={team.external_id} className="my-his-team">
                            <img className="banner" src={team.extra_data?.primary_banner_image} alt={team.name} />
                            <img className="logo" alt={team.name} src={team.logo_url} />
                            <div className="config">
                                <span className="name text-shadowed">{team.name}</span>
                                <RadioButton name={`${team.external_id}-togle`} label={labels.hide_team} defaultChecked={!profileWebsite.team_history_settings.team_settings?.[team.external_id]} />
                                <RadioButton name={`${team.external_id}-togle`} label={labels.show_team} defaultChecked={!!profileWebsite.team_history_settings.team_settings?.[team.external_id]} onChecked={(e) => {
                                    updateTeamVisibilitySetting(team, e);
                                }} />
                            </div>
                        </div>);
                    })}
                </div>
            </Form>)}
    </div>);

    function fetchTeams() {
        setTeams({});
        teamService.queryTeams({
            sort: searchParams.get("sort") ?? "",
            name: searchParams.get("name") ?? "",
            page: searchParams.get("page") ?? "1",
            size: searchParams.get("size") ?? "10",
            status: searchParams.get("status") ?? "",
            description: searchParams.get("description") ?? "",
        }).then(({ apiResponse }: SanitizedResponse<ITeam>) => {
            setTeams(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

    function updateProfileWebsite(updatedProfileWebsite: any, onDone?: () => void) {
        memberService.updateProfileWebsite(updatedProfileWebsite!).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
            Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

    function updateTeamVisibilitySetting(team: ITeam, show: boolean) {
        console.log("WE HERE");
        updateProfileWebsite({
            ...profileWebsite, team_history_settings: {
                ...profileWebsite?.team_history_settings,
                team_settings: {
                    ...profileWebsite?.team_history_settings?.team_settings,
                    [team.external_id]: show
                }
            }
        })
    }

}

export default TeamHistory;
